/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

export type V1ApiKeysCreateKeyRequestBody = {
  /**
   * Optional name for the API key.
   */
  name?: string | undefined;
  /**
   * Permissions to grant to the API key. Each permission must be within the caller's existing permissions.
   */
  permissions: Array<string>;
  /**
   * Expiration as Unix milliseconds, strictly in the future. Expiring root-key callers must provide a child expiry no later than their own. JWT admins and nonexpiring root-key callers may omit it or set null for no expiration.
   */
  expires?: number | null | undefined;
};

/** @internal */
export type V1ApiKeysCreateKeyRequestBody$Outbound = {
  name?: string | undefined;
  permissions: Array<string>;
  expires?: number | null | undefined;
};

/** @internal */
export const V1ApiKeysCreateKeyRequestBody$outboundSchema: z.ZodType<
  V1ApiKeysCreateKeyRequestBody$Outbound,
  z.ZodTypeDef,
  V1ApiKeysCreateKeyRequestBody
> = z.object({
  name: z.string().optional(),
  permissions: z.array(z.string()),
  expires: z.nullable(z.number().int()).optional(),
});

export function v1ApiKeysCreateKeyRequestBodyToJSON(
  v1ApiKeysCreateKeyRequestBody: V1ApiKeysCreateKeyRequestBody,
): string {
  return JSON.stringify(
    V1ApiKeysCreateKeyRequestBody$outboundSchema.parse(
      v1ApiKeysCreateKeyRequestBody,
    ),
  );
}
